function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 1893"
}, /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 639"
}, /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M5.001 4v13.693l3.055 3.055 1.833-1.833 1.833 1.833 1.833-1.833 1.833 1.833 3.055-3.055V4zm1.222 1.222h11v11.965L15.39 19.02l-1.836-1.833-1.833 1.833-1.833-1.833-1.833 1.833-1.832-1.833zm1.222 2.444v1.222h6.109V7.666zm7.331 0v1.222h1.222V7.666zm-7.331 3.055v1.216h6.109v-1.222zm7.331 0v1.216h1.222v-1.222zm-7.331 3.055v1.222h6.109v-1.222zm7.331 0v1.222h1.222v-1.222z",
  "data-name": "Path 78"
})));

var SvgPurchaser = function SvgPurchaser(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgPurchaser, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/purchaser.c652060f.svg";
export { ForwardRef as ReactComponent };